module.exports = __webpack_public_path__ + "static/bootstrap-card-image-caps-e3b7542509189252450484bc47160090.png";